import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { MenuItem, Settings } from '@/types'
import api from '@/services/api'
import { getImageUrl } from '@/utils/helpers'

function Header() {
  const [menus, setMenus] = useState<MenuItem[]>([])
  const [settings, setSettings] = useState<Settings | null>(null)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  useEffect(() => {
    api.get<MenuItem[]>('/menus')
      .then(data => setMenus(data.filter(m => m.is_visible)))
      .catch(err => console.error('Failed to load menus:', err))

    api.get<Settings>('/settings')
      .then(setSettings)
      .catch(err => console.error('Failed to load settings:', err))
  }, [])

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            {settings?.site_logo ? (
              <img
                src={getImageUrl(settings.site_logo)}
                alt={settings.candidate_name || 'Avenir Théopolitain'}
                className="logo-image"
              />
            ) : (
              <h1>{settings?.candidate_name || 'Avenir Théopolitain'}</h1>
            )}
          </Link>

          {/* Mobile menu toggle */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            ☰
          </button>

          {/* Navigation */}
          <nav className={`nav ${mobileMenuOpen ? 'open' : ''}`}>
            <ul>
              {menus.map(menu => (
                <li key={menu.id}>
                  <Link to={menu.route} onClick={() => setMobileMenuOpen(false)}>
                    {menu.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
